import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AdditionalMaterialImage = {
  __typename?: 'AdditionalMaterialImage';
  _id: Scalars['String'];
  imageUrl: Scalars['String'];
  materialId: Scalars['String'];
};

export type AdditionalMaterialImageInput = {
  baseId: Scalars['String'];
  materialId: Scalars['String'];
};

export type AdditionalPayment = {
  __typename?: 'AdditionalPayment';
  prices: Array<AdditionalPaymentPriceItem>;
  sku: Scalars['String'];
};

export type AdditionalPaymentInput = {
  price: Scalars['Float'];
  sku: Scalars['String'];
};

export type AdditionalPaymentPriceItem = {
  __typename?: 'AdditionalPaymentPriceItem';
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  price: Scalars['Float'];
};

export type Base = {
  __typename?: 'Base';
  _id: Scalars['String'];
  additionalMaterialImages: Array<AdditionalMaterialImage>;
  additionalPaidProduct?: Maybe<AdditionalPayment>;
  additionalPaidProductSKU?: Maybe<Scalars['String']>;
  additionalPayment?: Maybe<AdditionalPayment>;
  externalId?: Maybe<Scalars['Float']>;
  group?: Maybe<BaseGroup>;
  image?: Maybe<CdnFile>;
  images: Array<BaseMaterialImage>;
  isComplexBase: Scalars['Boolean'];
  isRibbon?: Maybe<Scalars['Boolean']>;
  materials: Array<Material>;
  name: Scalars['String'];
  nameTranslations: Translation;
  nodesImages: Array<BaseNodeImage>;
  selectedBindingId: Scalars['Float'];
  spacings: Array<Scalars['Float']>;
  /** translation key */
  translationKey: Scalars['String'];
  type?: Maybe<BaseType>;
  urlKey?: Maybe<Scalars['String']>;
};

export type BaseGroup = {
  __typename?: 'BaseGroup';
  _id: Scalars['String'];
  image?: Maybe<CdnFile>;
  isAdditionalMaterial?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<BaseType>;
};

export type BaseGroupsDataPage = {
  __typename?: 'BaseGroupsDataPage';
  items: Array<BaseGroup>;
  pageInfo: PageInfo;
};

export type BaseMaterialImage = {
  __typename?: 'BaseMaterialImage';
  _id: Scalars['String'];
  imageUrl: Scalars['String'];
  materialId: Scalars['String'];
  spacing?: Maybe<Scalars['Float']>;
};

export type BaseMaterialImageInput = {
  baseId: Scalars['String'];
  materialId: Scalars['String'];
  spacing?: InputMaybe<Scalars['Float']>;
};

export type BaseNodeImage = {
  __typename?: 'BaseNodeImage';
  _id: Scalars['String'];
  imageUrl: Scalars['String'];
  materialId: Scalars['String'];
};

export type BaseNodeImageInput = {
  baseId: Scalars['String'];
  materialId: Scalars['String'];
};

export type BaseSizeConfig = {
  __typename?: 'BaseSizeConfig';
  _id: Scalars['String'];
  base: Base;
  elementTypeLimits: Array<ElementTypeLimit>;
  rozmiar_swatch?: Maybe<Scalars['Float']>;
  size: Scalars['Float'];
  slots: Array<Slot>;
};

export type BaseSizeConfigsDataPage = {
  __typename?: 'BaseSizeConfigsDataPage';
  items: Array<BaseSizeConfig>;
  pageInfo: PageInfo;
};

export type BaseType = {
  __typename?: 'BaseType';
  _id: Scalars['String'];
  name: Scalars['String'];
};

export type BaseTypesDataPage = {
  __typename?: 'BaseTypesDataPage';
  items: Array<BaseType>;
  pageInfo: PageInfo;
};

export type BasesDataPage = {
  __typename?: 'BasesDataPage';
  items: Array<Base>;
  pageInfo: PageInfo;
};

export type CdnFile = {
  __typename?: 'CdnFile';
  _id: Scalars['String'];
  externalId: Scalars['String'];
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type CheckingSlotsForChangingBaseInput = {
  newBaseId: Scalars['String'];
  previousBaseId: Scalars['String'];
  previousBaseSizeConfigId: Scalars['String'];
  slotsWithElements: Array<SlotWithElementId>;
};

export type CheckingSlotsForChangingSizeInput = {
  baseId: Scalars['String'];
  currentBaseSizeConfigId: Scalars['String'];
  newBaseSizeConfigId: Scalars['String'];
  slotsWithElements: Array<SlotWithElementId>;
};

export type Color = {
  __typename?: 'Color';
  _id: Scalars['String'];
  hex: Scalars['String'];
  name: Scalars['String'];
};

export type ColorSettings = {
  __typename?: 'ColorSettings';
  externalId: Scalars['String'];
  image: Scalars['String'];
  name: Scalars['String'];
};

export type ColorsDataPage = {
  __typename?: 'ColorsDataPage';
  items: Array<Color>;
  pageInfo: PageInfo;
};

export type Configuration = {
  __typename?: 'Configuration';
  _id: Scalars['String'];
  content: Scalars['JSON'];
};

export type ConfigurationsDataPage = {
  __typename?: 'ConfigurationsDataPage';
  items: Array<Configuration>;
  pageInfo: PageInfo;
};

export type CreateBaseGroupInput = {
  image?: InputMaybe<Scalars['String']>;
  isAdditionalMaterial?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newImage?: InputMaybe<CreateCdnFileInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateBaseInput = {
  additionalPaidMaterialId?: InputMaybe<Scalars['String']>;
  additionalPayment?: InputMaybe<AdditionalPaymentInput>;
  externalId?: InputMaybe<Scalars['Float']>;
  group?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isComplexBase: Scalars['Boolean'];
  isRibbon?: InputMaybe<Scalars['Boolean']>;
  materials: Array<Scalars['String']>;
  /** key to translate */
  name: Scalars['String'];
  nameTranslations?: CreateTranslationInput;
  newImage?: InputMaybe<CreateCdnFileInput>;
  selectedBindingId: Scalars['Float'];
  spacings?: InputMaybe<Array<Scalars['Float']>>;
  type?: InputMaybe<Scalars['String']>;
  urlKey?: InputMaybe<Scalars['String']>;
};

export type CreateBaseSizeConfigInput = {
  base: Scalars['String'];
  newSlots: Array<CreateSlotInput>;
  rozmiar_swatch?: InputMaybe<Scalars['Float']>;
  size: Scalars['Float'];
  slots: Array<Scalars['String']>;
};

export type CreateBaseTypeInput = {
  name: Scalars['String'];
};

export type CreateCdnFileInput = {
  base64File: Scalars['String'];
  filename: Scalars['String'];
};

export type CreateColorInput = {
  hex: Scalars['String'];
  name: Scalars['String'];
};

export type CreateConfigurationInput = {
  content: Scalars['JSON'];
};

export type CreateElementInput = {
  externalId?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
  sku: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateElementTypeInput = {
  externalId?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
};

export type CreateElementTypeLimitInput = {
  baseSizeConfig: Scalars['String'];
  elementType: Scalars['String'];
  limit: Scalars['Float'];
};

export type CreateEngraveProductsInput = {
  backNameTranslations?: CreateTranslationInput;
  frontNameTranslations?: CreateTranslationInput;
  priceMap?: PriceMapInput;
  sku: Scalars['String'];
};

export type CreateManyBaseSizeConfigsInput = {
  base: Scalars['String'];
  newSlots: Array<CreateSlotInput>;
  rozmiar_swatch?: InputMaybe<Scalars['Float']>;
  sizes: Array<Scalars['Float']>;
  slots: Array<Scalars['String']>;
};

export type CreateManyElementTypeLimitsInput = {
  baseSizeConfigIds: Array<Scalars['String']>;
  elements: Array<ElementTypeLimitsItem>;
};

export type CreateMaterialInput = {
  color?: InputMaybe<Scalars['String']>;
  color_swatch?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameTranslations?: CreateTranslationInput;
  nodeImage?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  sku: Scalars['String'];
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateProductBundleInput = {
  data: Scalars['JSON'];
  quoteId: Scalars['JSON'];
};

export type CreateProductBundleResult = {
  __typename?: 'CreateProductBundleResult';
  data: Scalars['JSON'];
};

export type CreateSlotInput = {
  angle: Scalars['Float'];
  coordinates: Array<SlotCoordinatesInput>;
  elementTypes: Array<Scalars['String']>;
  hasSpacingImpact: Scalars['Boolean'];
  isNode?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
};

export type CreateTranslationInput = {
  cs?: InputMaybe<Scalars['String']>;
  de?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
  fr?: InputMaybe<Scalars['String']>;
  pl?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Dimension = {
  __typename?: 'Dimension';
  height: Scalars['Float'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export type Element = {
  __typename?: 'Element';
  _id: Scalars['String'];
  alfabet_swatch?: Maybe<Scalars['Float']>;
  backDimension?: Maybe<Dimension>;
  backUrl?: Maybe<Scalars['String']>;
  cyfry_swatch?: Maybe<Scalars['Float']>;
  engraveProducts: Array<EngraveProduct>;
  externalId?: Maybe<Scalars['Float']>;
  frontDimension?: Maybe<Dimension>;
  frontUrl?: Maybe<Scalars['String']>;
  html_description?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  kolor3_swatch?: Maybe<Scalars['Float']>;
  kolor_emalii_swatch?: Maybe<Scalars['Float']>;
  kolor_kamienia_swatch?: Maybe<Scalars['Float']>;
  material_swatch?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options?: Maybe<Scalars['JSON']>;
  order?: Maybe<Scalars['Float']>;
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rodzaj_kamienia_swatch?: Maybe<Scalars['String']>;
  rozmiar_swatch?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  sku: Scalars['String'];
  thumbnail: Scalars['String'];
  types: Array<ElementType>;
  upsell_products?: Maybe<Scalars['JSON']>;
  url_key?: Maybe<Scalars['String']>;
  znaki_zodiaku_swatch?: Maybe<Scalars['Float']>;
};

export enum ElementOrdering {
  Id = 'Id',
  Name = 'Name',
  Order = 'Order',
  Price = 'Price',
  Size = 'Size',
  Sku = 'Sku'
}

export type ElementSize = {
  __typename?: 'ElementSize';
  id: Scalars['Float'];
  label: Scalars['String'];
};

export type ElementType = {
  __typename?: 'ElementType';
  _id: Scalars['String'];
  externalId?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  positionX?: Maybe<Scalars['Float']>;
  positionY?: Maybe<Scalars['Float']>;
};

export type ElementTypeLimit = {
  __typename?: 'ElementTypeLimit';
  _id: Scalars['String'];
  baseSizeConfig: BaseSizeConfig;
  elementType: ElementType;
  limit: Scalars['Float'];
};

export type ElementTypeLimitsDataPage = {
  __typename?: 'ElementTypeLimitsDataPage';
  items: Array<ElementTypeLimit>;
  pageInfo: PageInfo;
};

export type ElementTypeLimitsItem = {
  elementTypeId: Scalars['String'];
  limit: Scalars['Float'];
};

export type ElementTypesDataPage = {
  __typename?: 'ElementTypesDataPage';
  items: Array<ElementType>;
  pageInfo: PageInfo;
};

export type ElementsDataPage = {
  __typename?: 'ElementsDataPage';
  items: Array<Element>;
  pageInfo: PageInfo;
};

export type EngraveProduct = {
  __typename?: 'EngraveProduct';
  _id: Scalars['String'];
  backNameTranslations: Translation;
  frontNameTranslations: Translation;
  priceMap: PriceMap;
  sku: Scalars['String'];
};

export type EngraveProductsDataPage = {
  __typename?: 'EngraveProductsDataPage';
  items: Array<EngraveProduct>;
  pageInfo: PageInfo;
};

export type FindVariantInput = {
  additionalMaterialSKU?: InputMaybe<Scalars['String']>;
  baseGroupId: Scalars['String'];
  baseId: Scalars['String'];
  selectedMaterialSKU: Scalars['String'];
  size: Scalars['Float'];
  slots: Array<SlotWithElement>;
};

export type ListBaseGroupInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  isAdditionalMaterial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type ListBaseInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['Float']>;
  group?: InputMaybe<Scalars['String']>;
  isRibbon?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type ListBaseSizeConfigInput = {
  _id?: InputMaybe<Scalars['String']>;
  base?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListBaseTypeInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListColorInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListConfigurationInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListElementForSlotInput = {
  currentPage?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<ElementOrdering>;
  ordering?: InputMaybe<Ordering>;
  pageSize?: InputMaybe<Scalars['Float']>;
  slotId: Scalars['String'];
};

export type ListElementInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
};

export type ListElementTypeInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListElementTypeLimitInput = {
  _id?: InputMaybe<Scalars['String']>;
  baseSizeConfig?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  elementType?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListEngraveProductsInput = {
  currentPage?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListMaterialInput = {
  _id?: InputMaybe<Scalars['String']>;
  base?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type ListSlotInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  isNode?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListUserInput = {
  _id?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type ListingForSlotResult = {
  __typename?: 'ListingForSlotResult';
  items: Array<Element>;
  pageInfo: PageInfo;
};

export type LogInInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LogInResult = {
  __typename?: 'LogInResult';
  access_token: Scalars['String'];
};

export type Material = {
  __typename?: 'Material';
  _id: Scalars['String'];
  color?: Maybe<Color>;
  colorSettings?: Maybe<ColorSettings>;
  color_swatch?: Maybe<Scalars['String']>;
  emaliaColorSettings?: Maybe<ColorSettings>;
  externalId?: Maybe<Scalars['Float']>;
  image: Scalars['String'];
  media_gallery?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  nameTranslations: Translation;
  nodeImage?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  prices: Array<PriceItem>;
  rodzajKamieniaSwatch?: Maybe<RodzajKamieniaSwatch>;
  rozmiar_swatch?: Maybe<Scalars['Float']>;
  sku: Scalars['String'];
  thumbnail: Scalars['String'];
  type: Scalars['String'];
};

export type MaterialsDataPage = {
  __typename?: 'MaterialsDataPage';
  items: Array<Material>;
  pageInfo: PageInfo;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAdditionalMaterialImage: Base;
  addBaseImage: Base;
  addNodeImage: Base;
  clearCache: Scalars['Boolean'];
  createBase: Base;
  createBaseGroup: BaseGroup;
  createBaseSizeConfig: BaseSizeConfig;
  createBaseType: BaseType;
  createColor: Color;
  createConfiguration: Configuration;
  createElement: Element;
  createElementType: ElementType;
  createElementTypeLimit: ElementTypeLimit;
  createEngraveProduct: EngraveProduct;
  createManyBaseSizeConfigs: Array<BaseSizeConfig>;
  createManyElementTypeLimits: Scalars['Boolean'];
  createMaterial: Material;
  createProductBundle: CreateProductBundleResult;
  createSlot: Slot;
  createUser: User;
  deleteBase: Scalars['Boolean'];
  deleteBaseGroup: Scalars['Boolean'];
  deleteBaseSizeConfig: Scalars['Boolean'];
  deleteBaseType: Scalars['Boolean'];
  deleteColor: Scalars['Boolean'];
  deleteConfiguration: Scalars['Boolean'];
  deleteElement: Scalars['Boolean'];
  deleteElementType: Scalars['Boolean'];
  deleteElementTypeLimit: Scalars['Boolean'];
  deleteEngraveProduct: Scalars['Boolean'];
  deleteMaterial: Scalars['Boolean'];
  deleteSlot: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  logIn: LogInResult;
  removeAdditionalMaterialImage: Base;
  removeBaseImage?: Maybe<Base>;
  removeNodeImage: Base;
  runIndex: Scalars['Boolean'];
  updateBase: Scalars['Boolean'];
  updateBaseGroup: Scalars['Boolean'];
  updateBaseSizeConfig: Scalars['Boolean'];
  updateBaseType: Scalars['Boolean'];
  updateColor: Scalars['Boolean'];
  updateConfiguration: Scalars['Boolean'];
  updateDimensions: Scalars['Boolean'];
  updateElement: Scalars['Boolean'];
  updateElementType: Scalars['Boolean'];
  updateElementTypeLimit: Scalars['Boolean'];
  updateEngraveProduct: Scalars['Boolean'];
  updateMaterial: Scalars['Boolean'];
  updateSlot: Scalars['Boolean'];
  updateUser: Scalars['Boolean'];
};


export type MutationAddAdditionalMaterialImageArgs = {
  input: UpdateAdditionalMaterialImageInput;
};


export type MutationAddBaseImageArgs = {
  input: UpdateBaseMaterialImageInput;
};


export type MutationAddNodeImageArgs = {
  input: UpdateBaseNodeImageInput;
};


export type MutationCreateBaseArgs = {
  input: CreateBaseInput;
};


export type MutationCreateBaseGroupArgs = {
  input: CreateBaseGroupInput;
};


export type MutationCreateBaseSizeConfigArgs = {
  input: CreateBaseSizeConfigInput;
};


export type MutationCreateBaseTypeArgs = {
  input: CreateBaseTypeInput;
};


export type MutationCreateColorArgs = {
  input: CreateColorInput;
};


export type MutationCreateConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationCreateElementArgs = {
  input: CreateElementInput;
};


export type MutationCreateElementTypeArgs = {
  input: CreateElementTypeInput;
};


export type MutationCreateElementTypeLimitArgs = {
  input: CreateElementTypeLimitInput;
};


export type MutationCreateEngraveProductArgs = {
  input: CreateEngraveProductsInput;
};


export type MutationCreateManyBaseSizeConfigsArgs = {
  input: CreateManyBaseSizeConfigsInput;
};


export type MutationCreateManyElementTypeLimitsArgs = {
  input: CreateManyElementTypeLimitsInput;
};


export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};


export type MutationCreateProductBundleArgs = {
  input: CreateProductBundleInput;
};


export type MutationCreateSlotArgs = {
  input: CreateSlotInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteBaseArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBaseGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBaseSizeConfigArgs = {
  id: Scalars['String'];
};


export type MutationDeleteBaseTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteColorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteConfigurationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteElementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteElementTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteElementTypeLimitArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEngraveProductArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSlotArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationLogInArgs = {
  input: LogInInput;
};


export type MutationRemoveAdditionalMaterialImageArgs = {
  input: AdditionalMaterialImageInput;
};


export type MutationRemoveBaseImageArgs = {
  input: BaseMaterialImageInput;
};


export type MutationRemoveNodeImageArgs = {
  input: BaseNodeImageInput;
};


export type MutationUpdateBaseArgs = {
  id: Scalars['String'];
  input: UpdateBaseInput;
};


export type MutationUpdateBaseGroupArgs = {
  id: Scalars['String'];
  input: UpdateBaseGroupInput;
};


export type MutationUpdateBaseSizeConfigArgs = {
  id: Scalars['String'];
  input: UpdateBaseSizeConfigInput;
};


export type MutationUpdateBaseTypeArgs = {
  id: Scalars['String'];
  input: UpdateBaseTypeInput;
};


export type MutationUpdateColorArgs = {
  id: Scalars['String'];
  input: UpdateColorInput;
};


export type MutationUpdateConfigurationArgs = {
  id: Scalars['String'];
  input: UpdateConfigurationInput;
};


export type MutationUpdateDimensionsArgs = {
  input: UpdateDimensions;
};


export type MutationUpdateElementArgs = {
  id: Scalars['String'];
  input: UpdateElementInput;
};


export type MutationUpdateElementTypeArgs = {
  id: Scalars['String'];
  input: UpdateElementTypeInput;
};


export type MutationUpdateElementTypeLimitArgs = {
  id: Scalars['String'];
  input: UpdateElementTypeLimitInput;
};


export type MutationUpdateEngraveProductArgs = {
  id: Scalars['String'];
  input: UpdateEngraveProductsInput;
};


export type MutationUpdateMaterialArgs = {
  id: Scalars['String'];
  input: UpdateMaterialInput;
};


export type MutationUpdateSlotArgs = {
  id: Scalars['String'];
  input: UpdateSlotInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String'];
  input: UpdateUserInput;
};

export type NewBaseSlotsMatchingResult = {
  __typename?: 'NewBaseSlotsMatchingResult';
  items: Array<SlotWithElementMatching>;
};

export enum Ordering {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Float'];
  pageSize: Scalars['Float'];
  totalCount: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PriceItem = {
  __typename?: 'PriceItem';
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  price: Scalars['Float'];
};

export type PriceMap = {
  __typename?: 'PriceMap';
  cs?: Maybe<Scalars['Float']>;
  de?: Maybe<Scalars['Float']>;
  en?: Maybe<Scalars['Float']>;
  fr?: Maybe<Scalars['Float']>;
  pl?: Maybe<Scalars['Float']>;
};

export type PriceMapInput = {
  cs?: InputMaybe<Scalars['Float']>;
  de?: InputMaybe<Scalars['Float']>;
  en?: InputMaybe<Scalars['Float']>;
  fr?: InputMaybe<Scalars['Float']>;
  pl?: InputMaybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  checkSlotsForChangingBase: NewBaseSlotsMatchingResult;
  checkSlotsForChangingSize: NewBaseSlotsMatchingResult;
  findBaseGroups: BaseGroupsDataPage;
  findBaseSizeConfigs: BaseSizeConfigsDataPage;
  findBaseTypes: BaseTypesDataPage;
  findBases: BasesDataPage;
  findColors: ColorsDataPage;
  findConfigurations: ConfigurationsDataPage;
  findElementTypeLimits: ElementTypeLimitsDataPage;
  findElementTypes: ElementTypesDataPage;
  findElements: ListingForSlotResult;
  findElementsForSlot: ListingForSlotResult;
  findEngraveProducts: EngraveProductsDataPage;
  findMaterials: MaterialsDataPage;
  findSizesForElementType: Array<ElementSize>;
  findSlots: SlotsDataPage;
  findUsers: UsersDataPage;
  findVariant: Variant;
};


export type QueryCheckSlotsForChangingBaseArgs = {
  input: CheckingSlotsForChangingBaseInput;
};


export type QueryCheckSlotsForChangingSizeArgs = {
  input: CheckingSlotsForChangingSizeInput;
};


export type QueryFindBaseGroupsArgs = {
  filters: ListBaseGroupInput;
};


export type QueryFindBaseSizeConfigsArgs = {
  filters: ListBaseSizeConfigInput;
};


export type QueryFindBaseTypesArgs = {
  filters: ListBaseTypeInput;
};


export type QueryFindBasesArgs = {
  filters: ListBaseInput;
};


export type QueryFindColorsArgs = {
  filters: ListColorInput;
};


export type QueryFindConfigurationsArgs = {
  filters: ListConfigurationInput;
};


export type QueryFindElementTypeLimitsArgs = {
  filters: ListElementTypeLimitInput;
};


export type QueryFindElementTypesArgs = {
  filters: ListElementTypeInput;
};


export type QueryFindElementsArgs = {
  filters: ListElementInput;
};


export type QueryFindElementsForSlotArgs = {
  filters: ListElementForSlotInput;
};


export type QueryFindEngraveProductsArgs = {
  filters: ListEngraveProductsInput;
};


export type QueryFindMaterialsArgs = {
  filters: ListMaterialInput;
};


export type QueryFindSizesForElementTypeArgs = {
  id: Scalars['String'];
};


export type QueryFindSlotsArgs = {
  filters: ListSlotInput;
};


export type QueryFindUsersArgs = {
  filters: ListUserInput;
};


export type QueryFindVariantArgs = {
  filters: FindVariantInput;
};

export type RodzajKamieniaSwatch = {
  __typename?: 'RodzajKamieniaSwatch';
  externalId: Scalars['String'];
  image: Scalars['String'];
  name: Scalars['String'];
};

export type Slot = {
  __typename?: 'Slot';
  _id: Scalars['String'];
  /** @deprecated Use coordinates array */
  angle: Scalars['Float'];
  coordinates: Array<SlotCoordinates>;
  elementTypes: Array<ElementType>;
  hasSpacingImpact: Scalars['Boolean'];
  isNode: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  name: Scalars['String'];
  /** @deprecated Use coordinates array */
  positionX: Scalars['Float'];
  /** @deprecated Use coordinates array */
  positionY: Scalars['Float'];
};

export type SlotCoordinates = {
  __typename?: 'SlotCoordinates';
  _id: Scalars['String'];
  angle: Scalars['Float'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  spacing?: Maybe<Scalars['Float']>;
};

export type SlotCoordinatesInput = {
  angle: Scalars['Float'];
  positionX: Scalars['Float'];
  positionY: Scalars['Float'];
  spacing?: InputMaybe<Scalars['Float']>;
};

export type SlotWithElement = {
  elementSKU: Scalars['String'];
  slotId: Scalars['String'];
};

export type SlotWithElementId = {
  elementId: Scalars['String'];
  slotId: Scalars['String'];
};

export type SlotWithElementMatching = {
  __typename?: 'SlotWithElementMatching';
  elementId: Scalars['String'];
  match: Scalars['Boolean'];
  slotId: Scalars['String'];
};

export type SlotsDataPage = {
  __typename?: 'SlotsDataPage';
  items: Array<Slot>;
  pageInfo: PageInfo;
};

export type Translation = {
  __typename?: 'Translation';
  cs?: Maybe<Scalars['String']>;
  de?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  fr?: Maybe<Scalars['String']>;
  pl?: Maybe<Scalars['String']>;
};

export type UpdateAdditionalMaterialImageInput = {
  baseId: Scalars['String'];
  image: Scalars['String'];
  materialId: Scalars['String'];
};

export type UpdateBaseGroupInput = {
  image?: InputMaybe<Scalars['String']>;
  isAdditionalMaterial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  newImage?: InputMaybe<CreateCdnFileInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateBaseInput = {
  additionalPaidMaterialId?: InputMaybe<Scalars['String']>;
  additionalPayment?: InputMaybe<AdditionalPaymentInput>;
  externalId?: InputMaybe<Scalars['Float']>;
  group?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isComplexBase?: InputMaybe<Scalars['Boolean']>;
  isRibbon?: InputMaybe<Scalars['Boolean']>;
  materials?: InputMaybe<Array<Scalars['String']>>;
  /** key to translate */
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<CreateTranslationInput>;
  newImage?: InputMaybe<CreateCdnFileInput>;
  selectedBindingId?: InputMaybe<Scalars['Float']>;
  spacings?: InputMaybe<Array<Scalars['Float']>>;
  type?: InputMaybe<Scalars['String']>;
  urlKey?: InputMaybe<Scalars['String']>;
};

export type UpdateBaseMaterialImageInput = {
  baseId: Scalars['String'];
  image: Scalars['String'];
  materialId: Scalars['String'];
  spacing?: InputMaybe<Scalars['Float']>;
};

export type UpdateBaseNodeImageInput = {
  baseId: Scalars['String'];
  image: Scalars['String'];
  materialId: Scalars['String'];
};

export type UpdateBaseSizeConfigInput = {
  base?: InputMaybe<Scalars['String']>;
  newSlots?: InputMaybe<Array<CreateSlotInput>>;
  rozmiar_swatch?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
  slots?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateBaseTypeInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateColorInput = {
  hex?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateConfigurationInput = {
  content?: InputMaybe<Scalars['JSON']>;
};

export type UpdateDimension = {
  height: Scalars['Float'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export type UpdateDimensions = {
  back?: InputMaybe<UpdateDimension>;
  front?: InputMaybe<UpdateDimension>;
  sku: Scalars['String'];
};

export type UpdateElementInput = {
  externalId?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateElementTypeInput = {
  externalId?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
};

export type UpdateElementTypeLimitInput = {
  baseSizeConfig?: InputMaybe<Scalars['String']>;
  elementType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type UpdateEngraveProductsInput = {
  backNameTranslations?: InputMaybe<CreateTranslationInput>;
  frontNameTranslations?: InputMaybe<CreateTranslationInput>;
  priceMap?: InputMaybe<PriceMapInput>;
  sku?: InputMaybe<Scalars['String']>;
};

export type UpdateMaterialInput = {
  color?: InputMaybe<Scalars['String']>;
  color_swatch?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<CreateTranslationInput>;
  nodeImage?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  sku?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateSlotInput = {
  angle?: InputMaybe<Scalars['Float']>;
  coordinates?: InputMaybe<Array<SlotCoordinatesInput>>;
  elementTypes?: InputMaybe<Array<Scalars['String']>>;
  hasSpacingImpact?: InputMaybe<Scalars['Boolean']>;
  isNode?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  positionX?: InputMaybe<Scalars['Float']>;
  positionY?: InputMaybe<Scalars['Float']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['String'];
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

export type UsersDataPage = {
  __typename?: 'UsersDataPage';
  items: Array<User>;
  pageInfo: PageInfo;
};

export type Variant = {
  __typename?: 'Variant';
  additionalMaterialId?: Maybe<Scalars['String']>;
  baseGroup?: Maybe<BaseGroup>;
  baseId: Scalars['String'];
  baseSizeConfigId?: Maybe<Scalars['String']>;
  baseSizeConfigs: Array<BaseSizeConfig>;
  bases: Array<Base>;
  elements: Array<VariantElement>;
  materialId?: Maybe<Scalars['String']>;
};

export type VariantElement = {
  __typename?: 'VariantElement';
  element: Element;
  slotId: Scalars['String'];
};

export type CheckSlotsForChangingBaseQueryVariables = Exact<{
  input: CheckingSlotsForChangingBaseInput;
}>;


export type CheckSlotsForChangingBaseQuery = { __typename?: 'Query', checkSlotsForChangingBase: { __typename?: 'NewBaseSlotsMatchingResult', items: Array<{ __typename?: 'SlotWithElementMatching', elementId: string, match: boolean, slotId: string }> } };

export type CheckSlotsForChangingSizeQueryVariables = Exact<{
  input: CheckingSlotsForChangingSizeInput;
}>;


export type CheckSlotsForChangingSizeQuery = { __typename?: 'Query', checkSlotsForChangingSize: { __typename?: 'NewBaseSlotsMatchingResult', items: Array<{ __typename?: 'SlotWithElementMatching', elementId: string, match: boolean, slotId: string }> } };

export type FindBaseGroupsQueryVariables = Exact<{
  filters: ListBaseGroupInput;
}>;


export type FindBaseGroupsQuery = { __typename?: 'Query', findBaseGroups: { __typename?: 'BaseGroupsDataPage', items: Array<{ __typename?: 'BaseGroup', _id: string, name: string, type?: { __typename?: 'BaseType', _id: string, name: string }, image?: { __typename?: 'CdnFile', _id: string, externalId: string, filename: string, url: string } }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindBaseSizesConfigsQueryVariables = Exact<{
  filters: ListBaseSizeConfigInput;
}>;


export type FindBaseSizesConfigsQuery = { __typename?: 'Query', findBaseSizeConfigs: { __typename?: 'BaseSizeConfigsDataPage', items: Array<{ __typename?: 'BaseSizeConfig', _id: string, size: number, base: { __typename?: 'Base', name: string, _id: string }, elementTypeLimits: Array<{ __typename?: 'ElementTypeLimit', limit: number, elementType: { __typename?: 'ElementType', name: string, _id: string } }>, slots: Array<{ __typename?: 'Slot', _id: string, angle: number, isNode: boolean, isRequired: boolean, name: string, positionX: number, positionY: number, elementTypes: Array<{ __typename?: 'ElementType', _id: string, externalId?: number, name: string }> }> }> } };

export type FindBaseTypesQueryVariables = Exact<{
  filters: ListBaseTypeInput;
}>;


export type FindBaseTypesQuery = { __typename?: 'Query', findBaseTypes: { __typename?: 'BaseTypesDataPage', items: Array<{ __typename?: 'BaseType', _id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindBasesQueryVariables = Exact<{
  filters: ListBaseInput;
}>;


export type FindBasesQuery = { __typename?: 'Query', findBases: { __typename?: 'BasesDataPage', items: Array<{ __typename?: 'Base', _id: string, externalId?: number, name: string, type?: { __typename?: 'BaseType', _id: string, name: string }, group?: { __typename?: 'BaseGroup', _id: string, name: string }, image?: { __typename?: 'CdnFile', _id: string, filename: string, url: string }, materials: Array<{ __typename?: 'Material', _id: string, color_swatch?: string, externalId?: number, image: string, nodeImage?: string, name: string, price?: number, sku: string, thumbnail: string }> }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindConfigurationsQueryVariables = Exact<{
  filters: ListConfigurationInput;
}>;


export type FindConfigurationsQuery = { __typename?: 'Query', findConfigurations: { __typename?: 'ConfigurationsDataPage', items: Array<{ __typename?: 'Configuration', _id: string, content: any }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindElementDimensionsQueryVariables = Exact<{
  filters: ListElementInput;
}>;


export type FindElementDimensionsQuery = { __typename?: 'Query', findElements: { __typename?: 'ListingForSlotResult', items: Array<{ __typename?: 'Element', backDimension?: { __typename?: 'Dimension', height: number, width: number, left: number, top: number }, frontDimension?: { __typename?: 'Dimension', height: number, width: number, left: number, top: number } }> } };

export type FindElementsQueryVariables = Exact<{
  filters: ListElementInput;
}>;


export type FindElementsQuery = { __typename?: 'Query', findElements: { __typename?: 'ListingForSlotResult', items: Array<{ __typename?: 'Element', _id: string, externalId?: number, image: string, name: string, sku: string, url_key?: string, price?: number, positionX?: number, positionY?: number, options?: any, rozmiar_swatch?: number, rodzaj_kamienia_swatch?: string, material_swatch?: string, html_description?: string, upsell_products?: any, types: Array<{ __typename?: 'ElementType', _id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindElementsBySkuQueryVariables = Exact<{
  filters: ListElementInput;
}>;


export type FindElementsBySkuQuery = { __typename?: 'Query', findElements: { __typename?: 'ListingForSlotResult', items: Array<{ __typename?: 'Element', _id: string, options?: any, rozmiar_swatch?: number, material_swatch?: string, rodzaj_kamienia_swatch?: string, kolor3_swatch?: number, kolor_emalii_swatch?: number, kolor_kamienia_swatch?: number, cyfry_swatch?: number, alfabet_swatch?: number, znaki_zodiaku_swatch?: number, types: Array<{ __typename?: 'ElementType', _id: string, name: string, positionX?: number, positionY?: number }>, engraveProducts: Array<{ __typename?: 'EngraveProduct', _id: string, sku: string, backNameTranslations: { __typename?: 'Translation', pl?: string, fr?: string, cs?: string, de?: string, en?: string }, frontNameTranslations: { __typename?: 'Translation', pl?: string, fr?: string, cs?: string, de?: string, en?: string }, priceMap: { __typename?: 'PriceMap', pl?: number, fr?: number, cs?: number, de?: number, en?: number } }> }> } };

export type FindSlotsQueryVariables = Exact<{
  filters: ListSlotInput;
}>;


export type FindSlotsQuery = { __typename?: 'Query', findSlots: { __typename?: 'SlotsDataPage', items: Array<{ __typename?: 'Slot', _id: string, name: string, angle: number, positionX: number, positionY: number, isRequired: boolean, isNode: boolean, elementTypes: Array<{ __typename?: 'ElementType', _id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', currentPage: number, pageSize: number, totalCount: number, totalPages: number } } };

export type FindVariantQueryVariables = Exact<{
  filters: FindVariantInput;
}>;


export type FindVariantQuery = { __typename?: 'Query', findVariant: { __typename?: 'Variant', baseId: string, baseSizeConfigId?: string, materialId?: string, additionalMaterialId?: string, bases: Array<{ __typename?: 'Base', _id: string, externalId?: number, name: string, selectedBindingId: number, isComplexBase: boolean, type?: { __typename?: 'BaseType', _id: string, name: string }, group?: { __typename?: 'BaseGroup', _id: string, name: string }, image?: { __typename?: 'CdnFile', _id: string, filename: string, url: string }, materials: Array<{ __typename?: 'Material', _id: string, color_swatch?: string, externalId?: number, image: string, nodeImage?: string, name: string, price?: number, sku: string, thumbnail: string, rozmiar_swatch?: number, colorSettings?: { __typename?: 'ColorSettings', externalId: string, image: string, name: string }, prices: Array<{ __typename?: 'PriceItem', countryCode: string, currency: string, price: number }>, emaliaColorSettings?: { __typename?: 'ColorSettings', externalId: string, image: string, name: string }, rodzajKamieniaSwatch?: { __typename?: 'RodzajKamieniaSwatch', externalId: string, image: string, name: string } }>, images: Array<{ __typename?: 'BaseMaterialImage', materialId: string, imageUrl: string, spacing?: number }>, nodesImages: Array<{ __typename?: 'BaseNodeImage', materialId: string, imageUrl: string }>, additionalMaterialImages: Array<{ __typename?: 'AdditionalMaterialImage', materialId: string, imageUrl: string }>, additionalPaidProduct?: { __typename?: 'AdditionalPayment', sku: string, prices: Array<{ __typename?: 'AdditionalPaymentPriceItem', countryCode: string, currency: string, price: number }> } }>, baseGroup?: { __typename?: 'BaseGroup', _id: string, name: string, type?: { __typename?: 'BaseType', _id: string, name: string }, image?: { __typename?: 'CdnFile', _id: string, externalId: string, filename: string, url: string } }, baseSizeConfigs: Array<{ __typename?: 'BaseSizeConfig', _id: string, size: number, base: { __typename?: 'Base', name: string, _id: string }, elementTypeLimits: Array<{ __typename?: 'ElementTypeLimit', limit: number, elementType: { __typename?: 'ElementType', name: string, _id: string } }>, slots: Array<{ __typename?: 'Slot', _id: string, angle: number, isNode: boolean, isRequired: boolean, name: string, positionX: number, positionY: number, hasSpacingImpact: boolean, elementTypes: Array<{ __typename?: 'ElementType', _id: string, externalId?: number, name: string }>, coordinates: Array<{ __typename?: 'SlotCoordinates', angle: number, positionX: number, positionY: number, spacing?: number }> }> }>, elements: Array<{ __typename?: 'VariantElement', slotId: string, element: { __typename?: 'Element', _id: string, image: string, name: string, sku: string, positionX?: number, positionY?: number, price?: number, rozmiar_swatch?: number, html_description?: string, upsell_products?: any, material_swatch?: string, url_key?: string, options?: any, rodzaj_kamienia_swatch?: string, engraveProducts: Array<{ __typename?: 'EngraveProduct', _id: string, sku: string, backNameTranslations: { __typename?: 'Translation', pl?: string, fr?: string, cs?: string, de?: string, en?: string }, frontNameTranslations: { __typename?: 'Translation', pl?: string, fr?: string, cs?: string, de?: string, en?: string }, priceMap: { __typename?: 'PriceMap', pl?: number, fr?: number, cs?: number, de?: number, en?: number } }>, types: Array<{ __typename?: 'ElementType', _id: string, name: string, positionX?: number, positionY?: number }> } }> } };

export type CreateConfigurationMutationVariables = Exact<{
  input: CreateConfigurationInput;
}>;


export type CreateConfigurationMutation = { __typename?: 'Mutation', createConfiguration: { __typename?: 'Configuration', _id: string, content: any } };

export type CreateProductBundleMutationVariables = Exact<{
  input: CreateProductBundleInput;
}>;


export type CreateProductBundleMutation = { __typename?: 'Mutation', createProductBundle: { __typename?: 'CreateProductBundleResult', data: any } };


export const CheckSlotsForChangingBaseDocument = gql`
    query CheckSlotsForChangingBase($input: CheckingSlotsForChangingBaseInput!) {
  checkSlotsForChangingBase(input: $input) {
    items {
      elementId
      match
      slotId
    }
  }
}
    `;

/**
 * __useCheckSlotsForChangingBaseQuery__
 *
 * To run a query within a React component, call `useCheckSlotsForChangingBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSlotsForChangingBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSlotsForChangingBaseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSlotsForChangingBaseQuery(baseOptions: Apollo.QueryHookOptions<CheckSlotsForChangingBaseQuery, CheckSlotsForChangingBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSlotsForChangingBaseQuery, CheckSlotsForChangingBaseQueryVariables>(CheckSlotsForChangingBaseDocument, options);
      }
export function useCheckSlotsForChangingBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSlotsForChangingBaseQuery, CheckSlotsForChangingBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSlotsForChangingBaseQuery, CheckSlotsForChangingBaseQueryVariables>(CheckSlotsForChangingBaseDocument, options);
        }
export type CheckSlotsForChangingBaseQueryHookResult = ReturnType<typeof useCheckSlotsForChangingBaseQuery>;
export type CheckSlotsForChangingBaseLazyQueryHookResult = ReturnType<typeof useCheckSlotsForChangingBaseLazyQuery>;
export type CheckSlotsForChangingBaseQueryResult = Apollo.QueryResult<CheckSlotsForChangingBaseQuery, CheckSlotsForChangingBaseQueryVariables>;
export const CheckSlotsForChangingSizeDocument = gql`
    query CheckSlotsForChangingSize($input: CheckingSlotsForChangingSizeInput!) {
  checkSlotsForChangingSize(input: $input) {
    items {
      elementId
      match
      slotId
    }
  }
}
    `;

/**
 * __useCheckSlotsForChangingSizeQuery__
 *
 * To run a query within a React component, call `useCheckSlotsForChangingSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSlotsForChangingSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSlotsForChangingSizeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSlotsForChangingSizeQuery(baseOptions: Apollo.QueryHookOptions<CheckSlotsForChangingSizeQuery, CheckSlotsForChangingSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSlotsForChangingSizeQuery, CheckSlotsForChangingSizeQueryVariables>(CheckSlotsForChangingSizeDocument, options);
      }
export function useCheckSlotsForChangingSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSlotsForChangingSizeQuery, CheckSlotsForChangingSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSlotsForChangingSizeQuery, CheckSlotsForChangingSizeQueryVariables>(CheckSlotsForChangingSizeDocument, options);
        }
export type CheckSlotsForChangingSizeQueryHookResult = ReturnType<typeof useCheckSlotsForChangingSizeQuery>;
export type CheckSlotsForChangingSizeLazyQueryHookResult = ReturnType<typeof useCheckSlotsForChangingSizeLazyQuery>;
export type CheckSlotsForChangingSizeQueryResult = Apollo.QueryResult<CheckSlotsForChangingSizeQuery, CheckSlotsForChangingSizeQueryVariables>;
export const FindBaseGroupsDocument = gql`
    query FindBaseGroups($filters: ListBaseGroupInput!) {
  findBaseGroups(filters: $filters) {
    items {
      _id
      name
      type {
        _id
        name
      }
      image {
        _id
        externalId
        filename
        url
      }
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindBaseGroupsQuery__
 *
 * To run a query within a React component, call `useFindBaseGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBaseGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBaseGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindBaseGroupsQuery(baseOptions: Apollo.QueryHookOptions<FindBaseGroupsQuery, FindBaseGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBaseGroupsQuery, FindBaseGroupsQueryVariables>(FindBaseGroupsDocument, options);
      }
export function useFindBaseGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBaseGroupsQuery, FindBaseGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBaseGroupsQuery, FindBaseGroupsQueryVariables>(FindBaseGroupsDocument, options);
        }
export type FindBaseGroupsQueryHookResult = ReturnType<typeof useFindBaseGroupsQuery>;
export type FindBaseGroupsLazyQueryHookResult = ReturnType<typeof useFindBaseGroupsLazyQuery>;
export type FindBaseGroupsQueryResult = Apollo.QueryResult<FindBaseGroupsQuery, FindBaseGroupsQueryVariables>;
export const FindBaseSizesConfigsDocument = gql`
    query FindBaseSizesConfigs($filters: ListBaseSizeConfigInput!) {
  findBaseSizeConfigs(filters: $filters) {
    items {
      _id
      base {
        name
        _id
      }
      size
      elementTypeLimits {
        limit
        elementType {
          name
          _id
        }
      }
      slots {
        _id
        angle
        elementTypes {
          _id
          externalId
          name
        }
        isNode
        isRequired
        name
        positionX
        positionY
      }
    }
  }
}
    `;

/**
 * __useFindBaseSizesConfigsQuery__
 *
 * To run a query within a React component, call `useFindBaseSizesConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBaseSizesConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBaseSizesConfigsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindBaseSizesConfigsQuery(baseOptions: Apollo.QueryHookOptions<FindBaseSizesConfigsQuery, FindBaseSizesConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBaseSizesConfigsQuery, FindBaseSizesConfigsQueryVariables>(FindBaseSizesConfigsDocument, options);
      }
export function useFindBaseSizesConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBaseSizesConfigsQuery, FindBaseSizesConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBaseSizesConfigsQuery, FindBaseSizesConfigsQueryVariables>(FindBaseSizesConfigsDocument, options);
        }
export type FindBaseSizesConfigsQueryHookResult = ReturnType<typeof useFindBaseSizesConfigsQuery>;
export type FindBaseSizesConfigsLazyQueryHookResult = ReturnType<typeof useFindBaseSizesConfigsLazyQuery>;
export type FindBaseSizesConfigsQueryResult = Apollo.QueryResult<FindBaseSizesConfigsQuery, FindBaseSizesConfigsQueryVariables>;
export const FindBaseTypesDocument = gql`
    query FindBaseTypes($filters: ListBaseTypeInput!) {
  findBaseTypes(filters: $filters) {
    items {
      _id
      name
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindBaseTypesQuery__
 *
 * To run a query within a React component, call `useFindBaseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBaseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBaseTypesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindBaseTypesQuery(baseOptions: Apollo.QueryHookOptions<FindBaseTypesQuery, FindBaseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBaseTypesQuery, FindBaseTypesQueryVariables>(FindBaseTypesDocument, options);
      }
export function useFindBaseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBaseTypesQuery, FindBaseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBaseTypesQuery, FindBaseTypesQueryVariables>(FindBaseTypesDocument, options);
        }
export type FindBaseTypesQueryHookResult = ReturnType<typeof useFindBaseTypesQuery>;
export type FindBaseTypesLazyQueryHookResult = ReturnType<typeof useFindBaseTypesLazyQuery>;
export type FindBaseTypesQueryResult = Apollo.QueryResult<FindBaseTypesQuery, FindBaseTypesQueryVariables>;
export const FindBasesDocument = gql`
    query FindBases($filters: ListBaseInput!) {
  findBases(filters: $filters) {
    items {
      _id
      externalId
      name
      type {
        _id
        name
      }
      group {
        _id
        name
      }
      image {
        _id
        filename
        url
      }
      materials {
        _id
        color_swatch
        externalId
        image
        nodeImage
        name
        price
        sku
        thumbnail
      }
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindBasesQuery__
 *
 * To run a query within a React component, call `useFindBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindBasesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindBasesQuery(baseOptions: Apollo.QueryHookOptions<FindBasesQuery, FindBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindBasesQuery, FindBasesQueryVariables>(FindBasesDocument, options);
      }
export function useFindBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindBasesQuery, FindBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindBasesQuery, FindBasesQueryVariables>(FindBasesDocument, options);
        }
export type FindBasesQueryHookResult = ReturnType<typeof useFindBasesQuery>;
export type FindBasesLazyQueryHookResult = ReturnType<typeof useFindBasesLazyQuery>;
export type FindBasesQueryResult = Apollo.QueryResult<FindBasesQuery, FindBasesQueryVariables>;
export const FindConfigurationsDocument = gql`
    query FindConfigurations($filters: ListConfigurationInput!) {
  findConfigurations(filters: $filters) {
    items {
      _id
      content
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindConfigurationsQuery__
 *
 * To run a query within a React component, call `useFindConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConfigurationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<FindConfigurationsQuery, FindConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindConfigurationsQuery, FindConfigurationsQueryVariables>(FindConfigurationsDocument, options);
      }
export function useFindConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindConfigurationsQuery, FindConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindConfigurationsQuery, FindConfigurationsQueryVariables>(FindConfigurationsDocument, options);
        }
export type FindConfigurationsQueryHookResult = ReturnType<typeof useFindConfigurationsQuery>;
export type FindConfigurationsLazyQueryHookResult = ReturnType<typeof useFindConfigurationsLazyQuery>;
export type FindConfigurationsQueryResult = Apollo.QueryResult<FindConfigurationsQuery, FindConfigurationsQueryVariables>;
export const FindElementDimensionsDocument = gql`
    query FindElementDimensions($filters: ListElementInput!) {
  findElements(filters: $filters) {
    items {
      backDimension {
        height
        width
        left
        top
      }
      frontDimension {
        height
        width
        left
        top
      }
    }
  }
}
    `;

/**
 * __useFindElementDimensionsQuery__
 *
 * To run a query within a React component, call `useFindElementDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindElementDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindElementDimensionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindElementDimensionsQuery(baseOptions: Apollo.QueryHookOptions<FindElementDimensionsQuery, FindElementDimensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindElementDimensionsQuery, FindElementDimensionsQueryVariables>(FindElementDimensionsDocument, options);
      }
export function useFindElementDimensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindElementDimensionsQuery, FindElementDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindElementDimensionsQuery, FindElementDimensionsQueryVariables>(FindElementDimensionsDocument, options);
        }
export type FindElementDimensionsQueryHookResult = ReturnType<typeof useFindElementDimensionsQuery>;
export type FindElementDimensionsLazyQueryHookResult = ReturnType<typeof useFindElementDimensionsLazyQuery>;
export type FindElementDimensionsQueryResult = Apollo.QueryResult<FindElementDimensionsQuery, FindElementDimensionsQueryVariables>;
export const FindElementsDocument = gql`
    query FindElements($filters: ListElementInput!) {
  findElements(filters: $filters) {
    items {
      _id
      externalId
      image
      name
      types {
        _id
        name
      }
      sku
      url_key
      price
      positionX
      positionY
      options
      rozmiar_swatch
      rodzaj_kamienia_swatch
      material_swatch
      html_description
      upsell_products
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindElementsQuery__
 *
 * To run a query within a React component, call `useFindElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindElementsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindElementsQuery(baseOptions: Apollo.QueryHookOptions<FindElementsQuery, FindElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindElementsQuery, FindElementsQueryVariables>(FindElementsDocument, options);
      }
export function useFindElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindElementsQuery, FindElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindElementsQuery, FindElementsQueryVariables>(FindElementsDocument, options);
        }
export type FindElementsQueryHookResult = ReturnType<typeof useFindElementsQuery>;
export type FindElementsLazyQueryHookResult = ReturnType<typeof useFindElementsLazyQuery>;
export type FindElementsQueryResult = Apollo.QueryResult<FindElementsQuery, FindElementsQueryVariables>;
export const FindElementsBySkuDocument = gql`
    query FindElementsBySku($filters: ListElementInput!) {
  findElements(filters: $filters) {
    items {
      _id
      options
      rozmiar_swatch
      material_swatch
      rodzaj_kamienia_swatch
      kolor3_swatch
      kolor_emalii_swatch
      kolor_kamienia_swatch
      cyfry_swatch
      alfabet_swatch
      znaki_zodiaku_swatch
      types {
        _id
        name
        positionX
        positionY
      }
      engraveProducts {
        _id
        backNameTranslations {
          pl
          fr
          cs
          de
          en
        }
        frontNameTranslations {
          pl
          fr
          cs
          de
          en
        }
        priceMap {
          pl
          fr
          cs
          de
          en
        }
        sku
      }
    }
  }
}
    `;

/**
 * __useFindElementsBySkuQuery__
 *
 * To run a query within a React component, call `useFindElementsBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindElementsBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindElementsBySkuQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindElementsBySkuQuery(baseOptions: Apollo.QueryHookOptions<FindElementsBySkuQuery, FindElementsBySkuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindElementsBySkuQuery, FindElementsBySkuQueryVariables>(FindElementsBySkuDocument, options);
      }
export function useFindElementsBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindElementsBySkuQuery, FindElementsBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindElementsBySkuQuery, FindElementsBySkuQueryVariables>(FindElementsBySkuDocument, options);
        }
export type FindElementsBySkuQueryHookResult = ReturnType<typeof useFindElementsBySkuQuery>;
export type FindElementsBySkuLazyQueryHookResult = ReturnType<typeof useFindElementsBySkuLazyQuery>;
export type FindElementsBySkuQueryResult = Apollo.QueryResult<FindElementsBySkuQuery, FindElementsBySkuQueryVariables>;
export const FindSlotsDocument = gql`
    query FindSlots($filters: ListSlotInput!) {
  findSlots(filters: $filters) {
    items {
      _id
      name
      elementTypes {
        _id
        name
      }
      angle
      positionX
      positionY
      isRequired
      isNode
    }
    pageInfo {
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
}
    `;

/**
 * __useFindSlotsQuery__
 *
 * To run a query within a React component, call `useFindSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSlotsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindSlotsQuery(baseOptions: Apollo.QueryHookOptions<FindSlotsQuery, FindSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSlotsQuery, FindSlotsQueryVariables>(FindSlotsDocument, options);
      }
export function useFindSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSlotsQuery, FindSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSlotsQuery, FindSlotsQueryVariables>(FindSlotsDocument, options);
        }
export type FindSlotsQueryHookResult = ReturnType<typeof useFindSlotsQuery>;
export type FindSlotsLazyQueryHookResult = ReturnType<typeof useFindSlotsLazyQuery>;
export type FindSlotsQueryResult = Apollo.QueryResult<FindSlotsQuery, FindSlotsQueryVariables>;
export const FindVariantDocument = gql`
    query FindVariant($filters: FindVariantInput!) {
  findVariant(filters: $filters) {
    bases {
      _id
      externalId
      name
      selectedBindingId
      type {
        _id
        name
      }
      group {
        _id
        name
      }
      image {
        _id
        filename
        url
      }
      materials {
        _id
        colorSettings {
          externalId
          image
          name
        }
        prices {
          countryCode
          currency
          price
        }
        emaliaColorSettings {
          externalId
          image
          name
        }
        rodzajKamieniaSwatch {
          externalId
          image
          name
        }
        color_swatch
        externalId
        image
        nodeImage
        name
        price
        prices {
          countryCode
          currency
          price
        }
        sku
        thumbnail
        rozmiar_swatch
      }
      images {
        materialId
        imageUrl
        spacing
      }
      nodesImages {
        materialId
        imageUrl
      }
      isComplexBase
      additionalMaterialImages {
        materialId
        imageUrl
      }
      additionalPaidProduct {
        sku
        prices {
          countryCode
          currency
          price
        }
      }
    }
    baseGroup {
      _id
      name
      type {
        _id
        name
      }
      image {
        _id
        externalId
        filename
        url
      }
    }
    baseSizeConfigs {
      _id
      base {
        name
        _id
      }
      size
      elementTypeLimits {
        limit
        elementType {
          name
          _id
        }
      }
      slots {
        _id
        angle
        elementTypes {
          _id
          externalId
          name
        }
        isNode
        isRequired
        name
        positionX
        positionY
        hasSpacingImpact
        coordinates {
          angle
          positionX
          positionY
          spacing
        }
      }
    }
    elements {
      slotId
      element {
        _id
        image
        name
        engraveProducts {
          _id
          backNameTranslations {
            pl
            fr
            cs
            de
            en
          }
          frontNameTranslations {
            pl
            fr
            cs
            de
            en
          }
          priceMap {
            pl
            fr
            cs
            de
            en
          }
          sku
        }
        types {
          _id
          name
          positionX
          positionY
        }
        sku
        positionX
        positionY
        price
        rozmiar_swatch
        html_description
        upsell_products
        material_swatch
        url_key
        options
        rodzaj_kamienia_swatch
      }
    }
    baseId
    baseSizeConfigId
    materialId
    additionalMaterialId
  }
}
    `;

/**
 * __useFindVariantQuery__
 *
 * To run a query within a React component, call `useFindVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVariantQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindVariantQuery(baseOptions: Apollo.QueryHookOptions<FindVariantQuery, FindVariantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVariantQuery, FindVariantQueryVariables>(FindVariantDocument, options);
      }
export function useFindVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVariantQuery, FindVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVariantQuery, FindVariantQueryVariables>(FindVariantDocument, options);
        }
export type FindVariantQueryHookResult = ReturnType<typeof useFindVariantQuery>;
export type FindVariantLazyQueryHookResult = ReturnType<typeof useFindVariantLazyQuery>;
export type FindVariantQueryResult = Apollo.QueryResult<FindVariantQuery, FindVariantQueryVariables>;
export const CreateConfigurationDocument = gql`
    mutation CreateConfiguration($input: CreateConfigurationInput!) {
  createConfiguration(input: $input) {
    _id
    content
  }
}
    `;
export type CreateConfigurationMutationFn = Apollo.MutationFunction<CreateConfigurationMutation, CreateConfigurationMutationVariables>;

/**
 * __useCreateConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConfigurationMutation, { data, loading, error }] = useCreateConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConfigurationMutation, CreateConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConfigurationMutation, CreateConfigurationMutationVariables>(CreateConfigurationDocument, options);
      }
export type CreateConfigurationMutationHookResult = ReturnType<typeof useCreateConfigurationMutation>;
export type CreateConfigurationMutationResult = Apollo.MutationResult<CreateConfigurationMutation>;
export type CreateConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateConfigurationMutation, CreateConfigurationMutationVariables>;
export const CreateProductBundleDocument = gql`
    mutation CreateProductBundle($input: CreateProductBundleInput!) {
  createProductBundle(input: $input) {
    data
  }
}
    `;
export type CreateProductBundleMutationFn = Apollo.MutationFunction<CreateProductBundleMutation, CreateProductBundleMutationVariables>;

/**
 * __useCreateProductBundleMutation__
 *
 * To run a mutation, you first call `useCreateProductBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBundleMutation, { data, loading, error }] = useCreateProductBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductBundleMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductBundleMutation, CreateProductBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductBundleMutation, CreateProductBundleMutationVariables>(CreateProductBundleDocument, options);
      }
export type CreateProductBundleMutationHookResult = ReturnType<typeof useCreateProductBundleMutation>;
export type CreateProductBundleMutationResult = Apollo.MutationResult<CreateProductBundleMutation>;
export type CreateProductBundleMutationOptions = Apollo.BaseMutationOptions<CreateProductBundleMutation, CreateProductBundleMutationVariables>;